import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MoonIcon, SunIcon } from "lucide-react";
import { useTheme } from "../../contexts/ThemeContext";
import { IconButton } from "./IconButton";
import { spring } from "../../utils/motion";
export function ThemeToggle() {
  const {
    resolved,
    toggle
  } = useTheme();
  const dark = resolved === "dark";
  return <IconButton label={dark ? "Switch to light mode" : "Switch to dark mode"} onClick={toggle} data-id="element-1235" data-mp="18t2i9az01cr6">
      <AnimatePresence mode="wait" initial={false} data-id="element-1236" data-mp="142cc3vir15vf">
        <motion.span key={resolved} initial={{
        rotate: -60,
        opacity: 0,
        scale: 0.8
      }} animate={{
        rotate: 0,
        opacity: 1,
        scale: 1
      }} exit={{
        rotate: 60,
        opacity: 0,
        scale: 0.8
      }} transition={spring.snappy} className="grid place-items-center" data-id="element-1237" data-mp="141khoo0w1e6q">
          {dark ? <SunIcon className="h-[18px] w-[18px]" strokeWidth={2.5} data-id="element-1238" data-mp="q1rw1747xo5m" /> : <MoonIcon className="h-[18px] w-[18px]" strokeWidth={2.5} data-id="element-1239" data-mp="l4j8ss47qtxi" />}
        </motion.span>
      </AnimatePresence>
    </IconButton>;
}